import {RestApiService, IRestApiService, TokenGetter} from '@techsee/techsee-client-infra/lib/services/RestApiService';
import {IResourceResponse} from '../components/session-summary/SessionSummary.contracts';
import {
    IHistoryService,
    ISearchByTagsParams,
    ISearchByTagsCountParams,
    IHistoryGetByCustomerIdParams,
    IHistorySearchData,
    IHistoryRoomParams,
    IHistoryGetByCustomerIdOrPhoneNumberParams,
    IHistoryGetbyCustomerNumberParams
} from '../states/history/_contracts/HistoryServiceContracts';

export class TsAppHistoryService implements IHistoryService {
    private _restApiService: IRestApiService;

    constructor(apiUrl: string, authToken: TokenGetter) {
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        this._restApiService = new RestApiService(baseUrl, authToken);
    }

    async room(params: IHistoryRoomParams): Promise<IResourceResponse> {
        const response = await this._restApiService.get('/api/history/room', {params: params.params});

        return 'data' in response ? response : {data: response};
    }

    async byCustomerId(params: IHistoryGetByCustomerIdParams): Promise<{data: IHistorySearchData}> {
        const response = await this._restApiService.get('/api/history/byCustomerId', {params: params.params});

        return 'data' in response ? response : {data: response};
    }

    async byCustomerIdOrNumber(
        params: IHistoryGetByCustomerIdOrPhoneNumberParams
    ): Promise<{data: IHistorySearchData}> {
        const response = await this._restApiService.get('/api/history/byCustomerIdOrNumber', {params: params.params});
        return 'data' in response ? response : {data: response};
    }

    async byCustomerNumber(params: IHistoryGetbyCustomerNumberParams): Promise<{data: IHistorySearchData}> {
        const response = await this._restApiService.get('/api/history/byCustomerNumber', {params: params.params});
        return 'data' in response ? response : {data: response};
    }

    async searchByTags(params: ISearchByTagsParams): Promise<any[]> {
        // Format dates as ISO strings for API
        const formattedParams = {
            ...params,
            fromDate: params.fromDate.toISOString(),
            toDate: params.toDate.toISOString()
        };
        const response = await this._restApiService.get('/api/history/searchByTags/search', {params: formattedParams});

        return Array.isArray(response) ? response : response.data || [];
    }

    async searchByTagsCount(params: ISearchByTagsCountParams): Promise<{matches: number}> {
        const formattedParams = {
            ...params,
            fromDate: params.fromDate.toISOString(),
            toDate: params.toDate.toISOString()
        };
        const response = await this._restApiService.get('/api/history/searchByTags/count', {params: formattedParams});

        return response.matches !== undefined ? response : {matches: response.data?.matches || 0};
    }
}
